import { Popconfirm, Checkbox } from 'antd';
import React, { forwardRef, useImperativeHandle, useRef, useEffect, useState } from 'react';
import {
  setTableColumnSelection,
  clearHyperVMessages,
  hyperVSelector,
} from '../../../../store/rvTools/hyperV/hyperV.reducer';
import { useAppDispatch, useAppSelector } from '../../../../store/app.hooks';
import {
  deleteHyperV,
  searchHyperV,
} from '../../../../store/rvTools/hyperV/hyperV.action';
import _ from 'lodash';
import hyperVService from '../../../../services/rvTools/hyperV/hyperV.service';
import {
  FilterByBooleanDropDown,
  FilterByDateSwap,
  FilterWithSwapOption,
} from '../../../../common/components/DataTable/DataTableFilters';
import { IMainTable, ISearch } from '../../../../common/models/common';
import { useHistory, useLocation } from 'react-router-dom';
import DataTable from '../../../../common/components/DataTable';
import ability, { Can } from '../../../../common/ability';
import { Action, Page } from '../../../../common/constants/pageAction';
import { AlignType } from 'rc-table/lib/interface';
import { showDateFromApi } from '../../../../common/helperFunction';

const MainTable: React.ForwardRefRenderFunction<unknown, IMainTable> = (props, ref) => {
  const {
    setSelectedId,
    setShowSelectedListModal,
    setValuesForSelection,
    isMultiple,
    setFilterKeys,
    tableButtons,
  } = props;
  const hyperV = useAppSelector(hyperVSelector);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idHyperV = queryParams.get('id');
  const dispatch = useAppDispatch();
  const dataTableRef = useRef(null);
  const history = useHistory();
  const [ObjectForColumnFilter, setObjectForColumnFilter] = useState({});

  useImperativeHandle(ref, () => ({
    refreshData() {
      dataTableRef?.current.refreshData();
    },
  }));

  useEffect(() => {
    if (isMultiple) {
      dataTableRef?.current.getValuesForSelection();
    }
  }, [isMultiple]);

  const exportExcelFile = (searchData: ISearch) => {
    return hyperVService.exportExcelFile(searchData);
  };

  const FilterBySwap = (dataIndex: string, form, isRelativeDropDownFlag?: boolean) => {
    setFilterKeys(ObjectForColumnFilter);
    return FilterWithSwapOption(
      dataIndex,
      hyperV.search.tableName,
      form,
      null,
      ObjectForColumnFilter,
      null,
      null,
      isRelativeDropDownFlag
    );
  };

  const FilterByDateSwapTable = (dataIndex: string, tableName: string, form: any, isTime?: boolean) => {
    return FilterByDateSwap(dataIndex, tableName, form, null, ObjectForColumnFilter, isTime);
  };

  const getTableColumns = (form) => {
    return [
      {
        title: <span className="dragHandler">ID</span>,
        column: 'id',
        sorter: true,
        ellipsis: true,
        children: [
          {
            title: FilterBySwap('id', form),
            dataIndex: 'id',
            key: 'id',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Tenant Name</span>,
        column: 'TenantId',
        sorter: true,
        children: [
          {
            title: FilterBySwap(
              'tenant_id',
              form,
              true
            ),
            dataIndex: 'tenant_name',
            key: 'tenant_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Company Name</span>,
        column: 'CompanyId',
        sorter: true,
        children: [
          {
            title: FilterBySwap(
              'company_id',
              form,
              true
            ),
            dataIndex: 'company_name',
            key: 'company_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Bu Name</span>,
        column: 'BU_Id',
        sorter: true,
        children: [
          {
            title: FilterBySwap(
              'bu_id',
              form,
              true
            ),
            dataIndex: 'bu_name',
            key: 'bu_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Date Added</span>,
        column: 'Date Added',
        sorter: true,
        children: [
          {
            title: FilterByDateSwapTable('date_added', hyperV.search.tableName, form),
            dataIndex: 'date_added',
            key: 'date_added',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Creation Time</span>,
        column: 'CreationTime',
        sorter: true,
        children: [
          {
            title: FilterByDateSwapTable('creation_time', hyperV.search.tableName, form, true),
            dataIndex: 'creation_time',
            key: 'creation_time',
            ellipsis: true,
            render: (date: Date) => (!_.isNull(date) ? showDateFromApi(date) : ''),
          },
        ],
      },
      {
        title: <span className="dragHandler">Source</span>,
        column: 'Source',
        sorter: true,
        children: [
          {
            title: FilterBySwap('source', form),
            dataIndex: 'source',
            key: 'source',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">VM Name</span>,
        column: 'VMName',
        sorter: true,
        children: [
          {
            title: FilterBySwap('vm_name', form),
            dataIndex: 'vm_name',
            key: 'vm_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">VM Id</span>,
        column: 'VMId',
        sorter: true,
        children: [
          {
            title: FilterBySwap('vm_id', form),
            dataIndex: 'vm_id',
            key: 'vm_id',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Name</span>,
        column: 'Name',
        sorter: true,
        children: [
          {
            title: FilterBySwap('name', form),
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">State</span>,
        column: 'State',
        sorter: true,
        children: [
          {
            title: FilterBySwap('state', form),
            dataIndex: 'state',
            key: 'state',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">CPU Usage</span>,
        column: 'CPUUsage',
        sorter: true,
        children: [
          {
            title: FilterBySwap('cpu_usage', form),
            dataIndex: 'cpu_usage',
            key: 'cpu_usage',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Computer Name</span>,
        column: 'ComputerName',
        sorter: true,
        children: [
          {
            title: FilterBySwap('computer_name', form),
            dataIndex: 'computer_name',
            key: 'computer_name',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Processor Count</span>,
        column: 'ProcessorCount',
        sorter: true,
        children: [
          {
            title: FilterBySwap('processor_count', form),
            dataIndex: 'processor_count',
            key: 'processor_count',
            ellipsis: true,
          },
        ],
      },
      {
        title: <span className="dragHandler">Is Deleted</span>,
        column: 'IsDeleted',
        sorter: true,
        children: [
          {
            title: FilterByBooleanDropDown(
              'is_deleted',
              hyperV.search.tableName,
              ObjectForColumnFilter
            ),
            dataIndex: 'is_deleted',
            key: 'is_deleted',
            ellipsis: true,
            render: (value: boolean) =>
              !_.isNull(value) ? (
                value ? (
                  <Checkbox checked disabled />
                ) : (
                  <Checkbox checked={false} disabled />
                )
              ) : (
                ''
              ),
            align: 'center' as AlignType,
          },
        ],
      },
    ];
  };

  const removeHyperV = (id: number) => {
    dispatch(deleteHyperV(id));
  };
  const tableAction = (_, data: any) => (
    <div className="btns-block">
      <Can I={Action.Update} a={Page.HyperV}>
        <a
          className="action-btn"
          onClick={() => {
            setSelectedId(data.id);
            history.push(`/rv-tools/virtualization-hyper-v/${data.id}`);
          }}
        >
          <img src={`${process.env.PUBLIC_URL}/assets/images/ic-edit.svg`} alt="" />
        </a>
      </Can>
      <Can I={Action.Delete} a={Page.HyperV}>
        <Popconfirm title="Delete Record?" onConfirm={() => removeHyperV(data.id)}>
          <a href="#" title="" className="action-btn">
            <img src={`${process.env.PUBLIC_URL}/assets/images/ic-delete.svg`} alt="" />
          </a>
        </Popconfirm>
      </Can>
    </div>
  );

  return (
    <>
      <DataTable
        ref={dataTableRef}
        showAddButton={ability.can(Action.Add, Page.HyperV)}
        setSelectedId={setSelectedId}
        tableAction={tableAction}
        exportExcelFile={exportExcelFile}
        getTableColumns={getTableColumns}
        reduxSelector={hyperVSelector}
        searchTableData={searchHyperV}
        clearTableDataMessages={clearHyperVMessages}
        setTableColumnSelection={setTableColumnSelection}
        setShowSelectedListModal={setShowSelectedListModal}
        setValuesForSelection={setValuesForSelection}
        showBulkUpdate={ability.can(Action.Update, Page.HyperV)}
        setObjectForColumnFilter={setObjectForColumnFilter}
        extraSearchData={parseInt(idHyperV) > 0 ? {id: idHyperV?.toString()} : undefined}
        tableButtons={tableButtons}
        isIdFiltered={true}
      />
    </>
  );
};

export default forwardRef(MainTable);
